<app-megamenu></app-megamenu>

<div class="service-page">
  <div class="hero-section">
    <div class="hero-background"></div>
    <div class="container">
      <div class="hero-content">
        <h1>Mosquito Control Services</h1>
        <p class="hero-subtitle">Seasonal mosquito control programs to help you enjoy your outdoor spaces without the annoyance and health risks of mosquitoes.</p>
        <div class="hero-actions">
          <button mat-raised-button class="cta-button" (click)="navigateToContact()">
            <mat-icon>pest_control</mat-icon>
            Get Mosquito Control
          </button>
          <button mat-button class="phone-button" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            Call {{ config.phone.display }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <div class="container">
      <h2>Professional Mosquito Control</h2>
      <p>Mosquitoes can carry dangerous diseases and make outdoor activities unbearable. Our comprehensive mosquito control program reduces mosquito populations and helps you reclaim your yard.</p>
      
      <div class="features-grid">
        <div class="feature-card">
          <mat-icon>outdoor_grill</mat-icon>
          <h3>Yard Treatments</h3>
          <p>Comprehensive yard treatments targeting mosquito breeding and resting areas</p>
        </div>
        
        <div class="feature-card">
          <mat-icon>water_drop</mat-icon>
          <h3>Breeding Site Elimination</h3>
          <p>Identification and treatment of standing water where mosquitoes breed</p>
        </div>
        
        <div class="feature-card">
          <mat-icon>schedule</mat-icon>
          <h3>Seasonal Programs</h3>
          <p>Regular treatments throughout mosquito season for continuous protection</p>
        </div>
      </div>
    </div>
  </div>

  <div class="cta-section">
    <div class="container">
      <h2>Enjoy Your Yard Again</h2>
      <p>Don't let mosquitoes ruin your outdoor fun. Our proven mosquito control helps you reclaim your outdoor spaces.</p>
      <button mat-raised-button class="primary-cta" (click)="navigateToContact()">
        <mat-icon>pest_control</mat-icon>
        Schedule Treatment
      </button>
    </div>
  </div>
</div>

<app-footer></app-footer>